export enum SupplierGroupTabs {
    DETAILS = 'details',
    SPOT_PORT_AVAILABILITY = 'spotPortAvailability',
    TWO_STEP_AUTH = 'twoStepAuthentication',
    SSO = 'singleSignOn',
    DEVELOPERS = 'developers',
    SURCHARGES = 'surcharges',
}
